export default __webpack_public_path__ + "static/community-15399b10855406651cfce10cd3ed9b49.png";